<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item" aria-current="page">
        <a class=" text-decoration-none">
          <fa-icon icon="heart"></fa-icon>
          <span jhiTranslate="global.menu.ads">sedcard</span>
        </a>
      </li>
    </ol>
  </nav>
  <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
    <div  *ngFor="let sedcard of sedcards; trackBy: trackId"class="col">
      <div class="card shadow-sm">
<!--        <img [src]="sedcard.picUrl1"  class="img-fluid"  alt="isabelle">-->
        <img [src]="sedcard.picUrl1" height="400" class="object-fit-scale" alt="isabelle">
        <div class="card-body">
          <div class="text-center">
            <a   [routerLink]="['/sedcard', sedcard.id, 'view']">{{ sedcard.name }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
